import API from "../../API";
import Utility from "../../Utility";

export function updateSupplement(data) {
  return API.postForm(Utility.getUrlAjax('updateBookingServiceAction'), data)
}

export function getOptionsList({ bookingId, establishmentId, organizationId }) {
  return API.post(
    Utility.getUrlAjax("optionsList"),
    JSON.stringify({
      bookingId,
      establishmentId,
      organizationId,
    })
  );
}

export function cancelSupplement({ supplement, bookingId }) {
  let supplementType = "";
  let supplementId = "";

  if (supplement?.optionId) {
    supplementType = "option";
    supplementId = supplement.optionId;
  }

  if (supplement?.extraId) {
    supplementType = "extra";
    supplementId = supplement.extraId;
  }

  const dataToSend = new URLSearchParams({
    bookingId,
    supplementType,
    supplementId,
  });

  return API.post(Utility.getUrlAjax("cancelSupplement"), dataToSend);
}